module.exports = __webpack_public_path__ + "static/img/kv.8273910.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/kv.jpg
// module id = b6tz
// module chunks = 7